import axios from "axios";
import { baseURL } from "../../../../utils/http/http-common";

export const getTeacherDetails = async (secretKey, teacherId) => {
  try {
    const response = await axios.post(
      `${baseURL}/SoapApiGCSESS/GetTeacherDetails`,
      {
        teacherId: teacherId,
        secretKey: secretKey,
      },
      {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json-patch+json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching teacher details:", error);
  }
};

export const getStudentDetails = async (
  schoolId,
  standard,
  setctionId,
  secretKey
) => {
  try {
    const response = await axios.post(
      `${baseURL}/SoapApiGCSESS/GetStudentDetails`,
      {
        schoolId: schoolId,
        standard: standard,
        section: setctionId,
        secretKey: secretKey,
      },
      {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json-patch+json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching teacher details:", error);
  }
};

//export default getTeacherDetails;
